import {Alert} from "@mui/joy";
import {createFileRoute, Navigate} from "@tanstack/react-router";
import {useSelf} from "../../../agent/useSelf.ts";
import {useTranslation} from "react-i18next";
import {SuspenseDialog} from "../../../components/SuspenseDialog.tsx";
import {defaultInspectionSettings} from "../../../inspector/navi.tsx";

function VenueSwitchboard() {
    const {id} = Route.useParams();
    const {t} = useTranslation();
    const {data: self} = useSelf();
    if (!self) {
        return <SuspenseDialog message={t("loadingSelf")}/>;
    }
    // if (self.canDispatch) {
    //     return <Navigate replace={true} to="/venue/$id/dispatch/" params={{id}}/>
    // }
    if (self.canDrive) {
        return <Navigate replace={true} to="/venue/$id/service" params={{id}}/>
    }
    if (self.admitterFor?.id === id) {
        return <Navigate replace={true} to="/venue/$id/gate" params={{id}}/>
    }
    if (self.inspectorFor?.id === id) {
        return <Navigate replace={true} to="/venue/$id/inspect/waste" params={{id}}
                         search={defaultInspectionSettings}/>
    }
    if (self.supervisorFor?.id === id) {
        return <Navigate replace={true} to="/venue/$id/supervise/bundle" params={{id}}/>
    }
    return <Alert color="danger">why are you here?</Alert>
}

export const Route
    = createFileRoute("/_auth/venue/$id/")({
    component: VenueSwitchboard,
});
